import React from 'react';
import { observer } from 'mobx-react-lite';
import ReactConfetti from 'react-confetti';
import { useWindowSize } from 'react-use';
import { useConfettiStore } from 'src/stores/ConfettiStore/ConfettiStore';

const ConfettiCanvas: React.FC = observer(() => {
  const { width, height } = useWindowSize();
  const { isActive } = useConfettiStore();

  if (!isActive) {
    return null;
  }

  return <ReactConfetti width={width} height={height} recycle={false} />;
});

export default ConfettiCanvas;
